import http from "../../core/services/http.service";

const MarketingService = {
  getAudiences(params) {
    return http.get('/api/v1/marketing/audiences/', {params});
  },
  getAudience(id, expand, params = {}) {
    return http.get(`/api/v1/marketing/audiences/${id}/?expand=${expand}`, {params});
  },
  createAudience(data, expand) {
    return http.post(`/api/v1/marketing/audiences/?expand=${expand}`, data);
  },
  getAudienceCustomers(uuid, params) {
    return http.get(`/api/v1/marketing/audiences/${uuid}/customers/`, {params});
  },
  updateAudience(id, data, expand) {
    return http.put(`/api/v1/marketing/audiences/${id}/?expand=${expand}`, data);
  },
  removeAudience(uuid) {
    return http.delete(`/api/v1/marketing/audiences/${uuid}`)
  },
  getCampaigns(params) {
    return http.get('/api/v1/marketing/campaigns/', {params});
  },
  createCampaign(data, expand) {
    return http.post(`/api/v1/marketing/campaigns/?expand=${expand}`, data);
  },
  updateCampaign(id, data, expand) {
    return http.put(`/api/v1/marketing/campaigns/${id}/?expand=${expand}`, data);
  },
  removeCustomersFromAudience(id, data) {
    return http.delete(`/api/v1/marketing/audiences/${id}/customers/`, {data});
  },
  getMarketingCustomers(params) {
    return http.get('/api/v1/marketing/customers/', {params});
  },
  addCustomersToAudience(id, data) {
    return http.post(`/api/v1/marketing/audiences/${id}/customers/`, data);
  },
  unsubscribeCustomersFromAudience(id, customer_uuids) {
    return http.put(`/api/v1/marketing/audiences/${id}/customers/`, customer_uuids);
  },
  getMailchimpInterests() {
    return http.get('/api/v1/marketing/interests/');
  }
};

export default MarketingService;
